import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  loadQuestions,
  submitAnswer,
  nextQuestion,
  previousQuestion,
  decrementTimer,
  endAssessment,
  resetQuiz,
} from "../../../../Redux/action/quizAction";
import { useNavigate } from "react-router-dom";


function formatTime(seconds) {
  const h = Math.floor(seconds / 3600)
    .toString()
    .padStart(2, "0");
  const m = Math.floor((seconds % 3600) / 60)
    .toString()
    .padStart(2, "0");
  const s = Math.floor(seconds % 60)
    .toString()
    .padStart(2, "0");
  return `${h}:${m}:${s}`;
}

export default function TakeAssessment() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {
    questions,
    currentQuestionIndex,
    assessmentTimeLeft,
    isAssessmentEnded,
    answers,
  } = useSelector((state) => state.quiz);
  console.log("isAssessmentEnded", isAssessmentEnded);
  useEffect(() => {
    dispatch(loadQuestions());
  }, []);

 useEffect(() => {
  if (questions.length > 0 && assessmentTimeLeft > 0 && !isAssessmentEnded) {
    const timerId = setInterval(() => {
      dispatch(decrementTimer());
    }, 1000);
    return () => clearInterval(timerId);
  } else if (
    questions.length > 0 &&
    assessmentTimeLeft === 0 &&
    !isAssessmentEnded
  ) {
    dispatch(endAssessment());
  }
}, [questions.length, assessmentTimeLeft, dispatch, isAssessmentEnded]);


  const currentQuestion = questions && questions[currentQuestionIndex];
  const questionType = currentQuestion?.questiontype;

  const options = [];
  if (questionType === "MCQ") {
    [1, 2, 3, 4].forEach((i) => {
      if (currentQuestion[`option${i}`])
        options.push(currentQuestion[`option${i}`]);
    });
  } else if (questionType === "TrueFalse") {
    options.push(currentQuestion.option1, currentQuestion.option2);
  }

  const handleAnswer = (selectedOption) => {
    dispatch(submitAnswer(currentQuestionIndex, selectedOption));
  };

  const handleSubmit = () => {
    dispatch(endAssessment());
    setTimeout(() => {
      console.log("dxf",isAssessmentEnded)
      dispatch(resetQuiz());
      navigate('/course-assessment/congrats')
    }, 1000);
  };

  return (
    <div
      style={{
        maxWidth: 700,
        margin: "3rem auto",
        fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
        padding: "1rem",
      }}
    >
      {questions?.length > 0 && (
        <>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "1.5rem",
              fontSize: "1rem",
              fontWeight: "600",
              color: "#333",
            }}
          >
            <div>
              Time Left:{" "}
              <span style={{ color: "#dc3545", fontWeight: "700" }}>
                {formatTime(assessmentTimeLeft)}
              </span>
            </div>
            <div>
              Question {currentQuestionIndex + 1} of {questions.length}
            </div>
          </div>

          <div
            style={{
              backgroundColor: "#fff",
              borderRadius: 10,
              boxShadow: "0 8px 20px rgba(0,0,0,0.1)",
              padding: "2rem",
              border: "1px solid #e3e3e3",
            }}
          >
            <h3
              style={{
                fontWeight: "700",
                fontSize: "1rem",
                color: "#222",
                marginBottom: "1.5rem",
              }}
            >
              {currentQuestion.questiontext}
            </h3>

            <div style={{ marginBottom: "2rem" }}>
              {questionType === "MCQ" &&
                options.map((opt, idx) => {
                  const optionKey = `option${idx + 1}`;
                  const isSelected =
                    answers[currentQuestionIndex] === optionKey;
                  return (
                    <button
                      key={idx}
                      onClick={() => handleAnswer(optionKey)}
                      style={{
                        display: "block",
                        width: "100%",
                        marginBottom: "0.75rem",
                        padding: "14px 20px",
                        backgroundColor: isSelected ? "#28a745" : "#f8f9fa",
                        color: isSelected ? "#fff" : "#212529",
                        border: isSelected ? "none" : "1px solid #ced4da",
                        borderRadius: 8,
                        cursor: "pointer",
                        fontSize: "0.8rem",
                        fontWeight: "600",
                        textAlign: "left",
                        boxShadow: isSelected
                          ? "0 4px 10px rgba(0,123,255,0.4)"
                          : "none",
                        transition: "all 0.2s ease",
                      }}
                    >
                      {opt}
                    </button>
                  );
                })}

              {questionType === "TrueFalse" &&
                options.map((opt, idx) => {
                  const isSelected = answers[currentQuestionIndex] === opt;
                  return (
                    <button
                      key={idx}
                      onClick={() => handleAnswer(opt)}
                      style={{
                        display: "inline-block",
                        minWidth: 120,
                        marginRight: idx < options.length - 1 ? 20 : 0,
                        padding: "14px 24px",
                        backgroundColor: isSelected ? "#28a745" : "#f8f9fa",
                        color: isSelected ? "#fff" : "#212529",
                        border: isSelected ? "none" : "1px solid #ced4da",
                        borderRadius: 8,
                        cursor: "pointer",
                        fontSize: "0.8rem",
                        fontWeight: "600",
                        boxShadow: isSelected
                          ? "0 4px 10px rgba(40,167,69,0.4)"
                          : "none",
                        transition: "all 0.2s ease",
                      }}
                    >
                      {opt}
                    </button>
                  );
                })}
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginBottom: "2rem",
              }}
            >
              <button
               className="newbutton"
                onClick={() => dispatch(previousQuestion())}
                disabled={currentQuestionIndex === 0}
                style={{
                  width: "20%",
                  marginRight: 12,
                  padding: "12px 0",
                  backgroundColor:"none!important",
                  background:'none!important',
                    // currentQuestionIndex === 0 ? "#adb5bd" : "#007bff",
                  color: currentQuestionIndex === 0 ? "#adb5bd" : "#007bff",
                  border: "1px solid #adb5bd",
                  borderRadius: 8,
                  fontWeight: "600",
                  fontSize: "0.9rem",
                  cursor:
                    currentQuestionIndex === 0 ? "not-allowed" : "pointer",
                }}
              >
                Previous
              </button>

              <button
                onClick={() => dispatch(nextQuestion())}
                disabled={
                  currentQuestionIndex === questions.length - 1 ||
                  !answers[currentQuestionIndex]
                }
                style={{
                  width: "20%",
                  marginLeft: 12,
                  padding: "12px 0",
                  backgroundColor:
                    currentQuestionIndex === questions.length - 1 ||
                    !answers[currentQuestionIndex]
                      ? "#adb5bd"
                      : "#007bff",
                  border: "none",
                  borderRadius: 8,
                  color: "#fff",
                  fontWeight: "600",
                  fontSize: "0.9rem",
                  cursor:
                    currentQuestionIndex === questions.length - 1 ||
                    !answers[currentQuestionIndex]
                      ? "not-allowed"
                      : "pointer",
                  boxShadow:
                    currentQuestionIndex === questions.length - 1 ||
                    !answers[currentQuestionIndex]
                      ? "none"
                      : "0 4px 10px rgba(0,123,255,0.4)",
                }}
              >
                Next
              </button>
            </div>

            {currentQuestionIndex === questions.length - 1 && (
              <div style={{ textAlign: "center" }}>
                <button
                  onClick={handleSubmit}
                  style={{
                    padding: "14px 40px",
                    borderRadius: 8,
                    border: "none",
                    backgroundColor: "#28a745",
                    color: "#fff",
                    fontWeight: "700",
                    fontSize: "0.9rem",
                    cursor: "pointer",
                    boxShadow: "0 6px 15px rgba(40,167,69,0.5)",
                  }}
                >
                  Submit Assessment
                </button>
              </div>
            )}
          </div>
        </>
      )}
    </div>
  );
}
